import { useTranslation } from 'react-i18next'

import type { ProjectUserRole } from '@maxus/common'

import { Select, type SelectOption } from '../base/select'

type ProjectRoleSelectProps = {
  ariaLabel: string
  disabled?: boolean
  onValueChange: (value: ProjectUserRole) => void
  value: ProjectUserRole
}

export const ProjectRoleSelect = ({
  ariaLabel,
  disabled = false,
  onValueChange,
  value,
}: ProjectRoleSelectProps) => {
  const { t } = useTranslation()
  const roleOptions: SelectOption<ProjectUserRole>[] = [
    { label: t('Project admin'), value: 'admin' },
    { label: t('Member'), value: 'member' },
  ]

  return (
    <Select
      ariaLabel={ariaLabel}
      contentClassName="min-w-[136px]"
      disabled={disabled}
      onValueChange={onValueChange}
      options={roleOptions}
      sideOffset={0}
      triggerClassName="w-[136px]"
      value={value}
    />
  )
}
